import React, { useEffect } from "react";
import { Steps } from "intro.js-react";
import "intro.js/introjs.css?__remix_sideEffect__";
import { useTour } from "../../context/TourContext";
import { useRoot } from "../../context/RootContext";

export const ProfileTour = ({ onStep6 }) => {
  const { tourState, setTourState } = useTour();
  const { openProfileMenu, setOpenProfileMenu, setDisplayProductTour } =
  useRoot();

  const steps = [
  {
    element: "#introProfile",
    intro: `<h1 style="display: flex; align-items: center; gap: 8px; font-family: Poppins; margin-top: -15px; font-size: 16px; font-weight: 600; line-height: 24px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;"><span class="sparkle-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.9815 18.7248C16.6121 16.9175 14.4424 15.75 12 15.75C9.55761 15.75 7.38789 16.9175 6.01846 18.7248M17.9815 18.7248C19.8335 17.0763 21 14.6744 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 14.6744 4.1665 17.0763 6.01846 18.7248M17.9815 18.7248C16.3915 20.1401 14.2962 21 12 21C9.70383 21 7.60851 20.1401 6.01846 18.7248M15 9.75C15 11.4069 13.6569 12.75 12 12.75C10.3431 12.75 9 11.4069 9 9.75C9 8.09315 10.3431 6.75 12 6.75C13.6569 6.75 15 8.09315 15 9.75Z" stroke="#32363E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </span> Menu</h1>
      <p style="font-family: Poppins; font-size: 14px; font-weight: 400; line-height: 22px; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">View and update your profile, customize your avatar, and access your settings from here</p>`,
    position: "left",
    tooltipClass: "custom-tooltip",
    highlightClass: "custom-highlight",
    scrollTo: "tooltip"
  }];

  useEffect(() => {
    setTimeout(() => {
      const element = document.querySelector("#introProfile");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        setTourState((prev) => ({ ...prev, showProfileStep: true }));
      } else {
        console.error("Element not found: #introProfile");
      }
    }, 500);
  }, []);

  const onExit = () => {
    setDisplayProductTour(false);
    setTourState((prev) => ({
      ...prev,
      showProfileStep: false
    }));
    setTimeout(() => {
      setOpenProfileMenu(false);
    }, 300);
  };

  const onComplete = () => {
    setDisplayProductTour(false);
    setOpenProfileMenu(false);
    setTourState((prev) => ({
      ...prev,
      showProfileStep: false
    }));
  };

  const onBeforeChange = () => {
    setTourState((prev) => ({
      ...prev,
      currentStep: prev.currentStep + 1
    }));
  };

  return tourState.showProfileStep ?
  <Steps
    enabled={true}
    steps={steps}
    initialStep={0}
    onExit={onExit}
    onComplete={onComplete}
    onBeforeChange={onBeforeChange}
    options={{
      dontShowAgain: false,
      exitOnOverlayClick: false,
      showStepNumbers: false,
      showBullets: false,
      showProgress: false,
      prevLabel: "Back",
      skipLabel: "",
      doneLabel: "Done",
      tooltipClass: "custom-tooltip",
      highlightClass: "custom-highlight",
      scrollTo: true,
      scrollPadding: 100,
      positionPrecedence: ["bottom", "top", "right", "left"],
      disableInteraction: false
    }} /> :

  null;
};